var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "#0044c6"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2V14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0H2C0.895 0 0 0.895 0 2ZM6 4C7.105 4 8 4.895 8 6C8 7.105 7.105 8 6 8C4.895 8 4 7.105 4 6C4 4.895 4.895 4 6 4ZM3 11.1C3 10.102 4.999 9.6 6 9.6C7.001 9.6 9 10.102 9 11.1V12H3V11.1ZM16 7H12C11.448 7 11 6.552 11 6C11 5.448 11.448 5 12 5H16C16.552 5 17 5.448 17 6C17 6.552 16.552 7 16 7ZM16 11H12C11.448 11 11 10.552 11 10C11 9.448 11.448 9 12 9H16C16.552 9 17 9.448 17 10C17 10.552 16.552 11 16 11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVcard);
export default __webpack_public_path__ + "static/media/Vcard.300ef31c6289930651a917850f90ee1c.svg";
export { ForwardRef as ReactComponent };